import * as Yup from "yup";
import type { FormulaVariable, PlanningMonth } from "../../CostPanel.types";

// At most one decimal separator (dot or comma), any number of fraction digits.
// Empty is allowed (= "not entered"). The pattern alone would accept a lone
// "." / "," — the not-lone-separator test below rejects that.
export const decimalPattern = /^\d*[.,]?\d*$/;

const INVALID_NUMBER_MESSAGE = "Enter a valid number";

const decimalField = Yup.string()
  .matches(decimalPattern, INVALID_NUMBER_MESSAGE)
  .test(
    "not-lone-separator",
    INVALID_NUMBER_MESSAGE,
    (value) => !value || /\d/.test(value),
  );

// Field names come from runtime formula variables, so the shape is built per
// render rather than declared statically.
export const buildAddCostSchema = (
  formulaVariables: FormulaVariable[],
  planningMonths: PlanningMonth[],
) =>
  Yup.lazy(() =>
    Yup.object(
      Object.fromEntries(
        formulaVariables.map((variable) =>
          variable.inputType === "PER_MONTH"
            ? // nested object keyed by month
              [
                variable.id,
                Yup.object(
                  Object.fromEntries(
                    planningMonths.map((month) => [month.key, decimalField]),
                  ),
                ),
              ]
            : // flat string
              [variable.id, decimalField],
        ),
      ),
    ),
  );
